export const _LOAD_MODEL_ = 'Load:Word';
export const _SAVE_MODEL_ = 'Save:Word';
export const _DELETE_WORD_ = 'Delete:Word';

export const MODEL = {
  id: null,
  word: null,
};
